import axios from 'axios'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { monolithHttpClient } from 'src/editor/api/http-clients/monolith-http-client'
import { BaseEntityNewInterface } from 'src/shared/schemas/base-entity.schema'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'

export const fetchBlocks = () => monolithHttpClient.get('/blocks')

export const createMasterBlock = (
  content: BaseEntityNewInterface[],
  desktopPreview: string,
  title: string,
) =>
  monolithHttpClient.post(`/masters/blocks/v2`, {
    content: JSON.stringify(content),
    title,
    desktopPreview,
  })

export const createUserBlock = (
  content: BaseEntityNewInterface[],
  desktopPreview: string,
  title: string,
) =>
  monolithHttpClient.post('/users/blocks/v2', {
    content: JSON.stringify(content),
    title,
    desktopPreview,
  })

export const createCommonBlock = (
  locale: PageLocaleEnum,
  content: BaseEntityNewInterface[],
  desktopPreview: string,
  mobilePreview: string,
  title: string,
  category: string,
) => {
  return monolithHttpClient.post('/commons/blocks/v2', {
    locale,
    content: JSON.stringify(content),
    title,
    category,
    desktopPreview,
    mobilePreview,
  })
}

export const deleteUserBlock = (id: string) =>
  monolithHttpClient.delete(`/users/${id}/block`)

export const deleteCommonBlock = (id: string) =>
  monolithHttpClient.delete(`/commons/${id}/block`)

export const deleteMasterBlock = (id: string) =>
  monolithHttpClient.delete(`/masters/${id}/block`)

export const screenshotCreate = (
  entities: BaseEntityNewInterface[],
  rootEntityId: EntityIdType,
  files: File[],
  locale: PageLocaleEnum,
) =>
  axios.post(
    `${process.env.SYSTEME_IO_HOST}/api/dashboard/page-editor/block/screenshot/create`,
    {
      entities,
      rootEntityId,
      files,
      locale,
    },
  )
